// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
//
//
// localStorage.setItem('firebase:debug_mode', 'true');
//
// const firebaseConfig = {
//   apiKey: "AIzaSyCzD3nEqG34SfLJSOzGrxCHDqJaFnEnpjs",
//   authDomain: "fir-analytics-dd51e.firebaseapp.com",
//   projectId: "fir-analytics-dd51e",
//   storageBucket: "fir-analytics-dd51e.firebasestorage.app",
//   messagingSenderId: "145802046869",
//   appId: "1:145802046869:web:41902d8891e2a8315bda9c",
//   measurementId: "G-HLEBXJBSXR"
// };
//
// export const app = initializeApp(firebaseConfig);
// export const analytics = getAnalytics(app);

//prod
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyCRF_xd2xMByJLJSU6W5_XdiMhPTCUiMGY",
  authDomain: "merch-o-line.firebaseapp.com",
  databaseURL: "https://merch-o-line.firebaseio.com",
  projectId: "merch-o-line",
  storageBucket: "merch-o-line.firebasestorage.app",
  messagingSenderId: "901489506960",
  appId: "1:901489506960:web:d8a0bf29ab9f65e40f7615",
  measurementId: "G-GK8C0G02WW"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);